var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWelcomeBackgroundMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 335,
    viewBox: "0 0 375 335",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.90735e-06V335C3.80838 332.895 8.63309 330.71 13.9266 328.313C29.3765 321.316 48.8199 312.511 58.6455 298.614C65.7821 288.52 69.3866 277.789 72.8515 267.473C78.0675 251.943 82.9676 237.354 99.1252 227.297C112.771 218.804 122.881 217.619 132.502 216.491C141.84 215.396 150.717 214.356 161.919 206.739C181.494 193.429 187.187 174.189 192.954 154.703C193.887 151.549 194.823 148.389 195.819 145.247C202.971 122.687 212.84 104.676 237.586 90.3039C251.633 82.1449 263.561 83.2494 274.885 84.2981C283.509 85.0967 291.784 85.8629 300.379 82.4809C320.262 74.6579 333.135 57.5566 341.574 41.1829C349.123 26.5376 362.192 6.64118 375 1.90735e-06H0Z",
    fill: "url(#paint0_linear_2090_21)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2090_21",
    x1: 187.704,
    y1: 5.19079,
    x2: 187.704,
    y2: 335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A4050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465282"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeBackgroundMobile);
export default __webpack_public_path__ + "static/media/welcomeBackgroundMobile.222a2b71dc7ef17e8fd443b7945bddbb.svg";
export { ForwardRef as ReactComponent };